import { inject } from 'vue';
import type { InjectionKey } from 'vue';
import type { LayoutContentGate } from '../types/mainLayout.type';

/** Key con la que la raíz de composición (`main.ts`) registra el gate del contenido de MainLayout. */
export const LAYOUT_CONTENT_GATE_PROVIDER_KEY: InjectionKey<LayoutContentGate> =
  Symbol('layoutContentGateProvider');

/**
 * Devuelve el gate registrado o `null`.
 * No lanza: el gate es opcional y, sin él, MainLayout dibuja su contenido normal.
 */
export function injectLayoutContentGate(): LayoutContentGate | null {
  return inject(LAYOUT_CONTENT_GATE_PROVIDER_KEY, null);
}
